<template>
    <div v-if="this.showComponent">
        <h4>{{label}}</h4>
        <div class="row mb">
            <div class="col-md-12">
                <table class="brocom-table" v-if="savedDataPublisherStructure && savedDataPublisherStructure.length">
                    <thead>
                    <th v-for="key in publisherStructureKeys">
                        <template v-if="key.label !== ''">{{ trans('labels.'+key.label) }}</template>
                    </th>
                    </thead>
                    <tbody>
                    <tr v-for="elements in savedDataPublisherStructure">
                        <td v-for="key in publisherStructureKeys" v-if="key.id !== 'id_structure' && key.id !== 'user_id'">
                            <span v-if="elements[key.id] && !elements[key.id].length">{{elements[key.id].label}}</span>
                            <span v-else v-for="(item, key) in elements[key.id]" :class="[key > 0 ? 'mt-xs' : '', 'block']">{{item.label}}</span>
                        </td>
                        <td>
                            <div v-on:click="removeStructure(elements.id_structure)"
                                 class="brocom-button-icon">
                                <i class="brocom brocom-delete"></i>
                                <i class="brocom-button-icon-ripple"></i>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="row">
            <div class="col-md-2">
                <div class="form-group brocom-select2">
                    <label>{{ trans('labels.publisher') }}</label>
                    <select2 v-model="publisher" ref="publishers" :options="dataPublishers" :name="'publisher_id'"
                             :placeholder="trans('labels.publisher')"></select2>
                </div>
            </div>
            <div class="col-md-2">
                <div class="form-group brocom-select2">
                    <label>{{ trans('labels.redaction') }}</label>
                    <select2 :options="this.filteredEditorials" :name="'editorial_id'" :selected="entry.editorial_id"
                             :placeholder="trans('labels.redaction')"
                             multiple
                             :isAll="true"
                    ></select2>
                </div>
            </div>
            <div class="col-md-2">
                <div class="form-group brocom-select2">
                    <label>{{ trans('labels.title_group') }}</label>
                    <select2 :options="this.filteredTitleGroups"
                             :name="'title_group_id'"
                             :placeholder="trans('labels.title_group')"
                             multiple
                             :isAll="true"
                    ></select2>
                </div>
            </div>
            <div class="col-md-2">
                <div class="form-group brocom-select2">
                    <label>{{ trans('labels.agent') }}</label>
                    <select2 :options="this.filteredSalesPersons"
                             :name="'sales_person_id'"
                             :placeholder="trans('labels.agent')"
                             multiple
                             :isAll="true"
                    ></select2>
                </div>
            </div>
            <div class="col-md-2">
                <div class="form-group brocom-select2">
                    <label>{{ trans('labels.rate') }}</label>
                    <select2 :options="this.filteredTaxRate"
                             :name="'tax_rate'"
                             :disabled = "true"
                             :placeholder="trans('labels.rate')"
                             :selected = "'selectable'"
                             :isEmpty = "true"
                             ref="tax_rate"
                    ></select2>
                </div>
            </div>
        </div>
        <div class="row">
        <div class="col-md-2">
                <div class="form-group brocom-select2">
                    <label>{{ trans('labels.country') }}</label>
                    <select2 :options="this.filteredCountries"
                             :name="'country'"
                             :placeholder="trans('labels.country')"
                             multiple
                             :isAll="true"
                             :onChange="countryChanged"
                             ref="countries"
                    ></select2>
                </div>
            </div>
            <div class="col-md-2"  v-if="this.showBundesland">
                <div class="form-group brocom-select2">
                    <label>{{ trans('labels.state') }}</label>
                    <select2 :options="this.filteredBundeslands"
                             :name="'german_region'"
                             :placeholder="trans('labels.state')"
                             multiple
                             :isAll="true"
                             ref="bundesland"
                    ></select2>
                </div>
            </div>
          <div class="col-md-2">
            <div class="form-group brocom-select2">
              <label>{{ trans('labels.action_number') }}</label>
              <select2 :options="this.filteredActionNumber"
                       :name="'action_number'"
                       :placeholder="trans('labels.action_number')"
                       multiple
                       :isAll="true"
                       ref="actionNumber"
              ></select2>
            </div>
          </div>
            <div class="col-md-2">
                <div class="form-group brocom-select2">
                    <label>{{ trans('labels.customer_group') }}</label>
                    <select2 :options="this.filteredCustomersGroups"
                             :name="'customer_group_id'"
                             :placeholder="trans('labels.customer_group')"
                             multiple
                             :isAll="true"
                    ></select2>
                </div>
            </div>
            <div class="col-md-2">
                <div class="form-group brocom-select2">
                    <label>{{ trans('labels.branch2') }}</label>
                    <select2 :options="this.filteredBranch2"
                             :name="'branch2'"
                             :placeholder="trans('labels.branch2')"
                             multiple
                             :isAll="true"
                    ></select2>
                </div>
            </div>
            <div class="col-md-2">
                <button type="button" class="btn brocom-button-color" :disabled="!this.canSubmit"
                        v-on:click="addStructure">{{trans('labels.save')}}
                </button>
            </div>
        </div>
        <input name="structure" type="hidden" v-model="savedDataPublisherStructure">
    </div>
</template>

<script>
    import Select2 from './Select2.vue';
    import 'core-js/es6/array';
    import 'core-js/es7/array';
    import '@babel/polyfill';
    import Swal from 'sweetalert2'

    export default {
        components: {
            'SelectPub': Select2,
            'SelectEd': Select2,
            'SelectedTitle': Select2
        },
        props: {
            label: '',
            publishers: {
                type: Array,
                default() {
                    return []
                }
            },
            allEditorials: {
                type: Array,
                default() {
                    return []
                },
            },
            allTitleGroups: {
                type: Array,
                default() {
                    return []
                }
            },
            allSalesPersons: {
                type: Array,
                default() {
                    return []
                }
            },
            allTaxRate: {
                type: Array,
                default() {
                    return [];
                }
            },
            allCustomersGroups: {
                type: Array,
                default() {
                    return [];
                }
            },
            allBranch2: {
                type: Array,
                default() {
                    return [];
                }
            },
            allCountries: {
              type: Array,
              default() {
                  return [];
              }
            },
            allBundeslands: {
                type: Array,
                default() {
                    return [];
                }
            },
            allActionNumber: {
                type: Array,
                default() {
                  return [];
              }
            },
            userName: '',
            entry: {
                default() {
                    return {};
                }
            },
            publisherGroups: {
                type: Array,
                default() {
                    return []
                }
            },
            savedPublisherStructure: {
                type: Array,
                default() {
                    return [];
                }
            }
        },
        methods: {
            filleLinked(el) {
                var elements = ['Editorials', 'TitleGroups', 'SalesPersons', 'TaxRate', 'CustomersGroups', 'Countries', 'Bundeslands', 'Branch2', 'ActionNumber'];
                var self = this;

                elements.forEach(function (item) {
                    self.fillItems(el, item);
                });

                if (el) {
                    this.canSubmit = true;
                }
            },
            fillItems(el, element) {
                var self = this;
                var selectableItem = {label: 'Wählbar', value: 'selectable'};
                this['filtered' + element] = [];
                this['filtered' + element].push(selectableItem);

                this['all' + element].forEach(function (item) {
                    if ((item.publisher_id == el || item.publisher_id == undefined) && item.value !== 'all') {
                        self['filtered' + element].push(item);
                    }
                });

                if (element === 'CustomersGroups' && self['filtered' + element].length === 1) {
                    this['all' + element].forEach(function (item) {
                        if ((item.publisher_id == 0 || item.publisher_id == undefined) && item.value !== 'all') {
                            self['filtered' + element].push(item);
                        }
                    });
                }
            },
            addStructure() {
                var self = this;
                this.canSubmit = false;

                var postData = {
                    user_id: this.entry.id
                };

                var isIe = false;

                this.$children.forEach(function (item, i) {
                    postData[item.nameLocal] = [];
                    if (self.$children[i].$el.selectedOptions === undefined) {
                        isIe = true;
                        self.$children[i].$el.selectedOptions = $('select[name= ' + self.$children[i].$el.name + '] option:selected');
                    }

                    Array.from(self.$children[i].$el.selectedOptions).forEach(function (elem, idx) {
                        postData[item.nameLocal][idx] = {};
                        postData[item.nameLocal][idx]['value'] = elem.value;
                        postData[item.nameLocal][idx]['label'] = elem.label;
                    });

                    if(isIe) self.$children[i].$el.selectedOptions = undefined;
                });

                for (var prop in postData) {
                    if (postData[prop] != undefined && postData[prop] != null && postData[prop].length == 0) {
                        postData[prop] = {value: 'all', label: 'all'};
                    }
                }

                var publisherId = postData.publisher_id[0].value;
                var isHeadOfGroup = false;

                self.publisherGroups.forEach(function (group){
                    if(group.group_id == publisherId){
                        isHeadOfGroup = true;
                    }
                });

                self.saveStructure(postData).then(function(res){
                    self.afterSave(postData, res);
                    if(isHeadOfGroup){
                        Swal.fire({
                            title: 'Achtung!',
                            text: "Wenn Sie einen Verlag mit Unterverlagen anlegen, müssen auch Rechte für Unterverlage vergeben werden. Möchten Sie dies nun tun?",
                            type: 'warning',
                            showCancelButton: true,
                            buttonsStyling: false,
                            reverseButtons: true,
                            showCloseButton: true,
                            focusConfirm: true,
                            customClass:{
                                confirmButton: 'btn brocom-button-color',
                                cancelButton: 'skin-brocom brocom-button',
                            },
                            confirmButtonText: 'Ja',
                            cancelButtonText: 'Nein'
                        }).then((result) => {
                            if (result.value) {
                                var subPublishers = [];

                                self.publisherGroups.forEach(function (pubGroup){
                                    var alreadyInStructure = false;

                                    if(pubGroup.group_id == publisherId) {
                                        var publisherName = '';

                                        self.publishers.forEach(function (pub) {
                                            if (pub.value == pubGroup.publisher_id) {
                                                publisherName = pub.label;
                                                return true;
                                            }
                                        });

                                        self.savedDataPublisherStructure.forEach(function (element) {
                                            if(Array.isArray(element.publisher_id)) {
                                                element.publisher_id = element.publisher_id[0];
                                            }

                                            if(element.publisher_id.value == pubGroup.publisher_id) {
                                                alreadyInStructure = true;
                                                return true;
                                            }
                                        });

                                        if (!alreadyInStructure) {
                                            subPublishers.push({
                                                user_id: self.entry.id,
                                                publisher_id: [{value: pubGroup.publisher_id, label: publisherName}],
                                                editorial_id: [{value: 'selectable', label: 'Wählbar'}],
                                                title_group_id: [{value: 'selectable', label: 'Wählbar'}],
                                                sales_person_id: [{value: 'selectable', label: 'Wählbar'}],
                                                tax_rate: [{value: 'selectable', label: 'Wählbar'}],
                                                country: [{value: 'selectable', label: 'Wählbar'}],
                                                german_region: [{value: 'selectable', label: 'Wählbar'}],
                                                customer_group_id: [{value: 'selectable', label: 'Wählbar'}],
                                                action_number: [{valus: 'selectable', label: 'Wählbar'}],
                                                branch2: [{value: 'selectable', label: 'Wählbar'}]
                                            });
                                        }
                                    }
                                });
                                for(let i=0; i<subPublishers.length; i++){
                                    self.saveStructure(subPublishers[i]).then(function(res){
                                        self.afterSave(subPublishers[i], res);
                                    }).catch(function(reason){
                                        console.log(reason);
                                    });
                                }
                            }
                        });
                    }
                }).catch(function(reason){
                    console.log(reason);
                });
            },
            saveStructure(postData) {
                var self= this;
                var canBeAdd = false;

                return new Promise((resolve, reject) => {
                    canBeAdd = self.publishers.some(publisher => publisher.value == postData.publisher_id[0].value);

                    if(canBeAdd) {
                        axios.post('/save_publisher_structure', {
                            data: postData
                        }).then(function (res) {
                            resolve(res);
                        });
                    } else {
                        reject('publisher '+postData.publisher_id[0].value+' not exist');
                    }
                });
            },
            afterSave(postData, res) {
                var self = this;

                this.publishers.forEach(function (item, i) {
                    if (item.value == postData.publisher_id[0].value) {
                        self.dataPublishers.splice(i, 1);
                        self.filleLinked(item.value);
                    }
                });
                postData.id_structure = res.data;
                self.savedDataPublisherStructure.push(postData);
                this.$nextTick(function () {
                    if (self.dataPublishers.length === 0) {
                        self.canSubmit = false;
                    }
                });
            },
            removeStructure(id_pub) {
                var self = this;
                brocomPreloader.show = true;
                axios.post('/delete_publisher_structure', {
                    data: id_pub
                }).then(function (res) {
                    self.savedDataPublisherStructure.forEach(function (item, idx) {
                        var publisher_id = (Array.isArray(item.publisher_id)) ? item.publisher_id[0].value : item.publisher_id.value;
                        if (res.data.id == publisher_id) {
                            self.savedDataPublisherStructure.splice(idx, 1);
                        }
                    });

                    var indexPlace = 0;
                    var positionSet = false;
                    self.publishers.forEach(function (item, i) {
                        if (item.label.localeCompare(res.data.name) == 1 && !positionSet) {
                            indexPlace = i;
                            positionSet = true;
                        }
                    });

                    self.dataPublishers.unshift({label: res.data.id.toString().padStart(3, '0') + ': ' + res.data.name, value: res.data.id});
                    self.publisher = res.data.id;
                    brocomPreloader.show = false;
                });
            },
            countryChanged(val){
                if(val.indexOf('D')>-1 || val == 'selectable'){
                    this.showBundesland = true;
                } else {
                    this.showBundesland = false;
                }
            }
        },
        data: function () {
            return {
                filteredEditorials: [],
                filteredTitleGroups: [],
                filteredSalesPersons: [],
                filteredCustomersGroups: [],
                filteredBranch2: [],
                filteredTaxRate: [],
                filteredCountries: [],
                filteredBundeslands: [],
                filteredActionNumber: [],
                showComponent: true,
                canSubmit: false,
                removeOptions: false,
                isHeadGroup: false,
                savedDataPublisherStructure: [],
                dataPublishers: [],
                publisher: 1,
                showBundesland: true,
                publisherStructureKeys: [
                    {id: 'publisher_id', label: 'publisher'},
                    {id: 'editorial_id', label: 'redaction'},
                    {id: 'title_group_id', label: 'title_group'},
                    {id: 'sales_person_id', label: 'agent'},
                    {id: 'tax_rate', label: 'rate'},
                    {id: 'country', label: 'country'},
                    {id: 'german_region', label: 'state'},
                    {id: 'action_number', label: 'action_number'},
                    {id: 'customer_group_id', label: 'customer_group'},
                    {id: 'branch2', label: 'branch2'},
                    {id: 'id_structure', label: ''}
                ]
            }
        },
        mounted: function () {
            this.savedDataPublisherStructure = this.savedPublisherStructure;
            this.dataPublishers = this.publishers;
            this.$nextTick(function () {
                var self = this;
                var userEl = $('.checkbox:contains(' + self.userName + ')').find('input[type="radio"]');
                if (!userEl.prop('checked')) this.showComponent = false;
                $('.checkbox').find('input[type="radio"]').bind('change', function () {
                    self.showComponent = userEl.prop('checked');
                });
            });
        },
        watch: {
            value: function (value) {
                $(this.$el).val(value).trigger('change');
            },
            publisher: function(value) {
                if(Array.isArray(value) && value.length > 0) {
                    value = value[0];
                }
                if(value != null) {
                    this.filleLinked(value);
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/PublisherEditorComponent.vue